export default [
    {
        path: '/activity-offereds',
        name: 'activity-offereds',
        component: () => import ('./views/ActivityOfferedIndex'),
        meta: { title: 'Ofertas', icon: 'mdi-clipboard-text-outline' },
    },
]
